import React, { Dispatch, SetStateAction } from 'react';
import { Modal, View } from 'react-native';
import { translate } from '../../../services/translate';
import FormActions from '../../../components/FormActions';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import MyAppText from '../../../components/MyAppText';
import UnitFinishEarlyDropdown from '../../../components/app-agent/UnitFinishEarlyDropdown';
import { useAuth } from '../../../context/Auth';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    onClose: () => void;
    finishEarlyReason: number;
    setFinishEarlyReason: Dispatch<SetStateAction<number>>;
    unitId: number;
}

export default function FinishEarlyModal({ onClose, finishEarlyReason, setFinishEarlyReason, isModalVisible, setModalVisible, unitId }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const { user: authenticatedUser } = useAuth();

    if (!authenticatedUser || unitId === 0) {
        return;
    }

    return (
        <Modal
            transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                setModalVisible(false);
                setFinishEarlyReason(0);
            }}
        >
            <View style={styles.container}>
                <View style={styles.formContainer}>
                    <View style={{ flexDirection: 'column', rowGap: 8 }}>
                        <MyAppText style={styles.header}>{translate('unitDeactivation')}</MyAppText>
                        <MyAppText style={styles.subheader}>{translate('earlyFinishAgentReason')}</MyAppText>
                    </View>
                    <View style={{ flexDirection: 'column', rowGap: 8 }}>
                        <MyAppText style={styles.inputLabelStyle}>{translate('unitDeactivationReason')}</MyAppText>
                        <UnitFinishEarlyDropdown
                            label=''
                            value={finishEarlyReason}
                            setValue={setFinishEarlyReason}
                            unitId={unitId}
                        />
                    </View>
                    <FormActions
                        buttonStyle={{ paddingHorizontal: 16, paddingVertical: 9 }}
                        onSubmit={() => {
                            onClose();
                            setModalVisible(false);
                        }}
                        onClose={() => {
                            setModalVisible(false);
                            setFinishEarlyReason(0);
                        }}
                        disabled={!finishEarlyReason} />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1,
        paddingHorizontal: 16,
    },
    formContainer: {
        minWidth: 300,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        paddingHorizontal: 16,
        paddingVertical: 24,
        rowGap: 32
    },
    header: {
        fontSize: 18,
        fontWeight: '700',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
    },
    subheader: {
        fontSize: 14,
        fontWeight: '400',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
    inputLabelStyle: {
        fontSize: 14,
        fontWeight: '600',
        flexWrap: 'wrap',
        color: theme.colors.modal.header,
        marginBottom: 8,
    },
}));
